<template>
  <section>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">Заявка отправлена!</v-card-title>

          <v-card-text>
            Хорошего дня!
          </v-card-text>

        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>

<script>
export default {
  name: 'Modal',
  data () {
    return {
    }
  },
  computed: {
    dialog: {
      get () {
        return this.$store.state.Final.dialog
      },
      set (value) {
        this.$store.commit('updateDialog', value)
      }
    }
  }
}
</script>

<style>

</style>
